import { render, staticRenderFns } from "./PopupInfoMethodColumn.vue?vue&type=template&id=48db8820&scoped=true&"
import script from "./PopupInfoMethodColumn.vue?vue&type=script&lang=js&"
export * from "./PopupInfoMethodColumn.vue?vue&type=script&lang=js&"
import style0 from "./PopupInfoMethodColumn.vue?vue&type=style&index=0&id=48db8820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48db8820",
  null
  
)

export default component.exports